import { Component } from 'react';
import PropTypes from 'prop-types';
import {actions} from 'forms/rrf';
import { connect } from 'react-redux';

import SearchableSelect from '../elements/searchable-select';

class UserTitleSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [
        {
          label: 'Mr',
          value: 'Mr.'
        },
        {
          label: 'Mrs',
          value: 'Mrs.'
        },
        {
          label: 'Miss',
          value: 'Miss.'
        },
        {
          label: 'Ms',
          value: 'Ms.'
        },
      ],
      selected: null
    };
  }

  componentDidMount = () => {
    if (this.props.defaultValue) {
      this.setState({
        selected: this.props.defaultValue
      });
    }
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.defaultValue !== prevProps.defaultValue) {
      this.setState({
        selected: this.props.defaultValue
      });
    }
  }

  handleChange = (value) => {
    const { model } = this.props;
    this.props.dispatch(actions.change(model, value));
    this.setState({
      selected: value
    });
  };

  render() {
    const { label, model } = this.props;
    const { options, selected } = this.state;
    return (
      <SearchableSelect
        label={label}
        model={model}
        options={options}
        value={selected}
        onChange={value => this.handleChange(value)}
      />
    );
  }
}

UserTitleSelector.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

UserTitleSelector.defaultProps = {
  model: '.title',
  label: 'Title',
  disabled: false
};

export default connect()(UserTitleSelector);
